<template>
<div class="mt_140">

  <ccMenu ref="cc_menu"></ccMenu>
  <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

  <div class="container p-4" style="background: #171A28;">

      <!-- TOP2 ----------------------------------- -->
      <div class="row mb-4">
        <div class="col-md-12">

          <div class="row mb-3">
            <div class="col-md-12">
              <div v-if="torneio.tipo_id == 4" class="text_30 text_bold text_branco">{{jogos[0].time1_nome}} x {{jogos[0].time2_nome}}</div> 
              <div v-else class="text_30 text_bold text_branco">{{torneio.nome}} | Entrada: R$ {{formatarMoeda(torneio.taxa_entrada)}}</div>
              <div v-if="torneio.tipo_id == 4" class="text_13 text_bold text_cinza"> CANTO {{nomeMercadoEscolhido(torneio.mercado_escolhido)}}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2" v-if="torneio.status < 3">
              <div class="text_12 text_bold text_verde">AO VIVO EM:</div>
              <div class="text_20 text_bold text_laranja">{{time_regressivo}}</div>
            </div>
            <div class="col-md-8">
              <div class="card" style="background: #E4E4E408 0% 0% no-repeat padding-box; border-radius: 8px;">
                <div class="card-body p-2">
                  <div class="row">
                    <div class="col-12">
                      <span class="text_12 text_cinza">Custo entrada: </span> <span class="text_12 text_bold text_cinza">R${{formatarMoeda(torneio.taxa_entrada)}}</span> &nbsp;
                      <span class="text_12 text_cinza">Re-entrada: </span> <span class="text_12 text_bold text_cinza">{{torneio.max_reentrada-1}}</span> &nbsp;
                      <span class="text_12 text_cinza">Participantes/Max:</span> <span class="text_12 text_bold text_cinza">{{torneio.qtd_aposta}}/{{torneio.max_pessoa}}</span> &nbsp;
                      <span class="text_12 text_cinza">Previsão de Término:</span> <span class="text_12 text_bold text_cinza">{{timestamp_dataBR(torneio.dt_termino_timestamp,4)}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <button v-if="torneio.status == 1 && torneio.tipo_id != 4" class="btn btn-success w-100 text_13 text_branco text_bold" style="text-decoration: none;" @click="perguntar_modal_mensagem(torneio_id)">
                  ENTRAR | R$ {{formatarMoeda(torneio.taxa_entrada)}}
              </button>
              <router-link v-else
                :to="{ name: 'minha_aposta_ws_redis', params: { torneio_id: torneio.id } }"
                type="button" class="btn btn-warning w-100 text_bold"
              > Voltar
              </router-link>
            </div>
          </div>

        </div>
      </div>
      <!-- TOP2  FIM----------------------------------- -->

      <!-- LINHA DAS COLUNAS --------------- -->
      <div class="row">
            <div class="col-md-8">

                <!-- descricao ---------- -->
                <div class="row mb-4">
                  <div class="col-md-12">
                    <div class="text_14 text_cinza text_bold mb-3">DESCRIÇÃO</div>
                    <div class="card card_fundo p-2">
                      <div class="card-body">
                        <div class="row text_cinza">
                            {{torneio.sumario}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- descricao fim---------- -->


                <!-- jogos---------------- -->
                <div class="row pb-4">
                  <div class="col-md-12">
                    <div class="text_14 text_branco">Jogos disponíveis: &nbsp; {{torneio.qtd_jogo}} Jogos </div>
                    <div class="text_14 text_branco mb-3">Você tem que escolher: &nbsp; {{torneio.qtd_mercado_obrigatorio}} Palpites </div>
                    <div class="card card_fundo">
                      <div class="card-body">
                        <div class="row">

                            <div v-for="l of liga" class="mb-3 text_cinza">
                                <div class="text_12 text_branco p-1 bg_preto">
                                  <span class="text_bold">
                                    <img :src='l.pais_logo' class="imagem" alt="Responsive image" :title='"sokkerduel"' width="22px" v-show="l.pais_logo != null">
                                    <img src="http://api.sokkerpro.net/assets/flags/99474.png" class="imagem" alt="Responsive image" :title='"sokkerduel"' width="22px" v-show="l.pais_logo == null">
                                    {{l.pais_nome}}:
                                  </span>
                                  <span>{{l.nome}}</span>
                                </div>
                                <div v-for="jogo of jogos" v-if="l.id == jogo.liga_id">
                                    <div class="row text_12 p-1">

                                      <div class="col-md-2">{{timestamp_dataBR(jogo.dt_inicio_timestamp,4)}}</div>

                                      <div class="col-md-4 text-end">
                                        {{jogo.time1_nome}}
                                      </div>
                                      <div class="col-md-1 text-center">
                                        -
                                      </div>
                                      <div class="col-md-4">
                                        {{jogo.time2_nome}}
                                      </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- jogos fim -->

                <!-- participantes-->
                <div class="row">
                  <div class="col-12">

                    <div class="row mb-3">
                      <div class="col-8">
                        <div class="text_14 text_cinza text_bold">PARTICIPANTES</div>
                      </div>
                      <div class="col-4">
                        <input type="text" v-model="filter_username" class="form-control form-control-sm" placeholder="Pesquisar" v-on:keyup="filter_participante()">
                      </div>
                    </div>

                    <div class="card card_fundo" style="height:170px; overflow: auto; ">
                      <div class="card-body">
                        <div class="row">

                            <div class="col-md-3 text_branco" v-for="a of apostas_filtradas" style="font-size:9px; padding:5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                               {{a.username}} {{a.entrada==1?"":"("+a.entrada+")"}}
                            </div>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <!--participantes fim -->

            </div>
            <!-- COLUNA 8 FIM ------------------------------- -->

            <div class="col-md-4">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 text_14 text_cinza text_bold mb-4">PREMIAÇÃO</div>

                      <div class="col-12 card_fundo p-3" style="min-height: 650px;">
                        <div v-for="item in prize" class="row p-2 text_cinza">

                          <div class="col-md-12 estrutura_ganhos_tabela text_bold text_12 p-1" style="border-bottom: 1px solid #7070704A;">
                            <div class="row">
                              <div class="col-md-6 estrutura_ganhos_tabela text_cinza text_bold text_15"> {{(item.p1 == item.p2)?item.p1+"º":item.p1+"º - "+item.p2+"º"}} </div>
                              <div class="col-md-6 estrutura_ganhos_tabela text_cinza text_15 text_bold text_verde text-end"> R$ {{ formatarMoeda(item.ganho/item.ranger) }} </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
            </div>
      </div>

  </div>

  <ccMensagem ref="cc_mensagem" @evento_teste="resposta_modal_mensagem"></ccMensagem>

  <ccFooter></ccFooter>

</div>
</template>

<script>
import axios from 'axios';
import ccMenu from '../layout/menu.vue'
import ccMensagem from '../cc_geral/mensagem.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccContagemRegressiva from '../cc_geral/cc_contagem_regressiva.vue'
import ccFooter from '../layout/footer.vue'

export default {
  data () {
    return {
      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],

      //variaveis
      user_logado: false,
      page_back: 0,
      tela_detalhes: true,
      tela_jogos_disponiveis: false,
      ultimo_que_ganha: 0,
      casa: 0,
      total_dinheiro: 0,
      banca: 0,
      filter_username: null,

      //array
      torneio: [],
      torneio_id: 0,
      prize: [],
      jogos: [],
      liga: [],
      apostas: [],
      apostas_filtradas: [],
      dt_inicio_timestamp: null,
      dt_termino_timestamp: null,
      ultimo_que_ganha: null,
      dif: 0,
      time_regressivo: 0,

      qtd_aposta: 0,
      porc_casa: 0,

      tela_detalhes: true,
      tela_jogos_disponiveis: false,
      ip: null,
    }
  },

  components: {ccMenu, ccMensagem, ccLoading, ccContagemRegressiva, ccFooter},

  created(){
    let a = JSON.parse(localStorage.getItem("user"))

    if (a == null){
      this.user = {}
    }else{
      this.user = a
    }

    if(Object.values(this.user).length != 0){
      this.user_logado = true
    }else{
      this.user_logado = false
    }

    this.torneio_id = this.$route.params.torneio_id;
    this.page_back = this.$route.params.page_back;

    this.get_torneio()

    this.get_aposta()

    this.start_time()
  },

  methods: {

    get_user(){
      this.loading = true
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'user', header)
      .then(response => {
        let a = response.data.data
        this.user.balance = a.balance
        localStorage.setItem("user", JSON.stringify(this.user));
        this.loading = false
      })
      .catch(e => {
        this.expluse_para_login()
      });
    },

    get_torneio(){
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'torneio/find_id/'+this.torneio_id, header)
      .then(response => {

        let agora = Date.now()
        let dif = ( (response.data.resp.torneio.dt_inicio_timestamp * 1000) - agora )
        dif = parseInt(dif/1000);

        this.torneio = response.data.resp.torneio
        this.torneio.dt_inicio = this.timestamp_dataBR(this.torneio.dt_inicio_timestamp)
        this.torneio.dt_termino = this.previsao_termino(this.torneio.dt_termino_timestamp)
        this.prize = response.data.resp.prize
        this.qtd_aposta = response.data.resp.torneio.qtd_aposta
        this.porc_casa = response.data.resp.torneio.porc_casa
        this.jogos = response.data.resp.jogo
        this.qtd_mercado_obrigatorio	 = response.data.resp.qtd_mercado_obrigatorio
        this.dt_inicio_timestamp = response.data.resp.dt_inicio_timestamp
        this.dt_termino_timestamp = response.data.resp.dt_termino_timestamp
        this.ultimo_que_ganha = this.prize[ response.data.resp.prize.length-1 ].p2
        this.dif = dif
        this.time_regressivo = 0

        this.higienizar_jogo()
        this.loading = false
      })
      .catch(e => {
        this.errors.push(e);
      });
    },

    get_aposta(){
        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.get(this.base_url_api+'torneio/'+this.torneio_id+'/aposta', header)
        .then(response => {

          this.loading = false;
          let a = response.data.resp;
          var obj = {};
          var aposta = [];
          var p = this.prize;
          var porc = 0;
          var ranger = 0;

          let colocacao = "";
          for (var i=0; i <= a.length -1; i++) {
            porc = 0;
            for (var c=0; c <= p.length -1; c++) {
              if(a[i].rank >= p[c].p1 && a[i].rank <= p[c].p2 ){
                porc = p[c].porcentagem;
                ranger = p[c].ranger;
              }
            }

            obj = {
              aposta_id: a[i].aposta_id,
              aposta_id_sec: a[i].aposta_id_sec.substr(0,8),
              rank: a[i].rank,
              repetido: a[i].repetido,
              usuario_id: a[i].usuario_id,
              username: a[i].username,
              ponto: a[i].ponto,
              entrada: a[i].entrada,
              prize:  (((this.banca * porc) / 100)/ranger)/a[i].repetido,
              cadeado: 0,
              escolha: 0,
            };
            aposta.push(obj);
          }

          this.apostas = aposta
          this.apostas_filtradas = aposta

        })
        .catch(e => {
        });
    },

    higienizar_jogo(){
      let obj = {}

      //higienizar jogos
      let j = this.jogos
      let jogo_aux = []
      for (var i=0; i <= j.length -1; i++){
        obj = {}
        obj.fixture_id = j[i].fixture_id
        obj.liga_id = j[i].liga_id
        obj.liga_nome = j[i].liga_nome
        obj.liga_logo = j[i].liga_logo
        obj.pais_nome = j[i].pais_nome
        obj.pais_logo = j[i].pais_logo
        obj.torneio_id = j[i].torneio_id
        obj.time1 = j[i].time1
        obj.time1_nome = j[i].time1_nome
        obj.time2 = j[i].time2
        obj.time2_nome = j[i].time2_nome
        obj.dt_inicio_timestamp = j[i].dt_inicio_timestamp
        obj.dt_termino_timestamp = j[i].dt_termino_timestamp
        obj.minute = j[i].minute
        obj.localteam_score = j[i].localteam_score == null ? j[i].localteam_score = 0 : j[i].localteam_score
        obj.visitorteam_score = j[i].visitorteam_score == null ? j[i].visitorteam_score = 0 : j[i].visitorteam_score
        obj.ht_score = j[i].ht_score
        obj.ft_score = j[i].ft_score
        obj.corner_ft = j[i].corner_ft
        obj.corner_ht = j[i].corner_ht
        obj.status = (j[i].status=='' || j[i].status==null) ? 'Aguardando' : j[i].status
        obj.status_descricao = j[i].status_descricao
        obj.localteam_logo = j[i].localteam_logo
        obj.visitorteam_logo = j[i].visitorteam_logo
        obj.ht = j[i].ht

        // obj.status = 4
        // obj.status_descricao = this.torneio_status_nome(obj.status)

        obj.aux = this.timestamp_dataBR(obj.dt_inicio_timestamp,3)

        if(obj.status=='LIVE' || obj.status=='HT'){
          obj.aux = ((obj.minute==''||obj.minute==null) ? 0 : obj.minute) + "'"
        }

        jogo_aux.push(obj)
      }
      this.jogos = jogo_aux

      //categorize por liga
      this.liga = []
      let found = -1
      let aux = []
      j = jogo_aux
      for (var i=0; i <= j.length -1; i++){
         obj = {}
         if( aux.indexOf( j[i].liga_id ) == -1 ){
            aux.push(j[i].liga_id)

            obj.id = j[i].liga_id
            obj.nome = j[i].liga_nome
            obj.logo = j[i].liga_logo
            obj.pais_nome = j[i].pais_nome
            obj.pais_logo = j[i].pais_logo
            this.liga.push(obj)
         }
      }
    },

    filter_participante(){
      let pesq = this.filter_username.toLowerCase();

      this.apostas_filtradas = this.apostas.filter(aposta =>
        aposta.username.toLowerCase().includes(pesq.toLowerCase())
      );
    },

    tela_detalhes_show(){
      this.tela_jogos_disponiveis = false
      this.tela_detalhes = true
    },

    tela_jogos_diponiveis_show(){
      this.tela_detalhes = false
      this.tela_jogos_disponiveis = true
    },

    voltar(){
      if(this.page_back == 0){
        this.$router.push({ path: '/', replace: true })
      }
      if(this.page_back == 1){
        this.$router.push({ path: '/home/torneio/0', replace: true })
      }
      if(this.page_back == 2){
        this.$router.push({ path: '/acontecendo', replace: true })
      }
    },

    //************** entrar na aposta ***************** */


    async perguntar_modal_mensagem(id)
    {
        this.torneio_id = id;
        this.ip = null;

        if(this.torneio.tipo_id == 3){
            await fetch('https://api.ipify.org?format=json')
            .then(response => response.json())
            .then(data => {
                this.ip = data.ip
            })
            .catch(error => {
              this.ip = null;
              this.error = 'Erro ao obter endereço IP: ' + error.message;
            });
        }

        var body = {
          usuario_id: this.user.id,
          torneio_id: this.torneio_id,
          ip: this.ip
        };

        var header = {'headers': {'x-access-token': this.user.access_token, }};
        await axios.post(this.base_url_api+'aposta/autorizacao', body, header)
        .then(response => {

          let m = response.data

          // usuario_bloqueado
          // dinheiro_insuficiente
          // torneio_iniciado
          // max_reentrada_atingido
          // max_aposta_atingido
          // tempo_aposta_esgotado

          //tudo certo para apostar sem apostas vazias
          if(m.status == 'success' && m.resp.aposta_check_vazia_count == 0){
            var obj = {
              cor: 1,
              titulo: 'ATENÇÃO',
              texto: 'Depois que entrar só poderá editar e não cancelar',
              btn1_ativo: true,
              btn1_cor: 1,
              btn1_texto: 'OK, CRIAR APOSTA',
              btn1_link: '#',
              btn1_link_next: false,
              btn2_ativo: true,
              btn2_cor: 2,
              btn2_texto: 'NÃO, SAIR',
              btn2_link: '#',
              btn2_link_next: false,
            }
            this.$refs.cc_mensagem.receber_dados(obj);
          }

          //tudo certo para apostar com apostas vazias
          if(m.status == 'success' && m.resp.aposta_check_vazia_count > 0){
            var obj = {
              cor: 1,
              titulo: 'VOCÊ TEM APOSTA VAZIAS',
              texto: 'Você deseja reentrada ou editar sua aposta?',
              btn1_ativo: true,
              btn1_cor: 1,
              btn1_texto: '+1 REENTRADA',
              btn1_link: '#',
              btn1_link_next: false,
              btn2_ativo: true,
              btn2_cor: 3,
              btn2_texto: 'EDITAR APOSTA',
              btn2_link: '/torneio/'+this.torneio_id,
              btn2_link_next: true,
            }
            this.$refs.cc_mensagem.receber_dados(obj);
          }

          if(
            m.resp.erro == 'usuario_bloqueado' || m.resp.erro == 'dinheiro_insuficiente' ||
            m.resp.erro == 'torneio_iniciado' ||
            m.resp.erro == 'max_aposta_atingido' || m.resp.erro == 'tempo_aposta_esgotado'
          ){
            var obj = {
              cor: 1,
              titulo: m.resp.erro,
              texto: null,
              btn1_ativo: false,
              btn1_cor: 1,
              btn1_texto: null,
              btn1_link: '#',
              btn1_link_next: true,
              btn2_ativo: true,
              btn2_cor: 2,
              btn2_texto: 'Voltar',
              btn2_link: null,
              btn2_link_next: true,
            }
            this.$refs.cc_mensagem.receber_dados(obj);
          }

        })
        .catch(e => {

          if(e.response.status == 400){

            if(e.response.data.slug == 'max_reentrada_atingido'){
                var obj = {
                  cor: 2,
                  titulo: e.response.data.msg,
                  texto: null,
                  btn1_ativo: true,
                  btn1_cor: 3,
                  btn1_texto: 'EDITAR APOSTA',
                  btn1_link: '/torneio/'+this.torneio_id,
                  btn1_link_next: true,
                  btn2_ativo: true,
                  btn2_cor: 2,
                  btn2_texto: 'VOLTAR',
                  btn2_link: null,
                  btn2_link_next: true,
                }

            }else{
                var obj = {
                    cor: 2,
                    titulo: e.response.data.msg,
                    texto: null,
                    btn1_ativo: false,
                    btn1_cor: 1,
                    btn1_texto: null,
                    btn1_link: '#',
                    btn1_link_next: true,
                    btn2_ativo: true,
                    btn2_cor: 2,
                    btn2_texto: 'Voltar',
                    btn2_link: null,
                    btn2_link_next: true,
                }
            }

            this.$refs.cc_mensagem.receber_dados(obj);
            return
          }

          if(e.response.status == 401){
            var obj = {
                  cor: 1,
                  titulo: 'Para apostar precisa está logado!',
                  texto: 'Faça o login!!',
                  btn1_ativo: true,
                  btn1_cor: 1,
                  btn1_texto: 'ACESSAR',
                  btn1_link: '/login',
                  btn1_link_next: true,
                  btn2_ativo: true,
                  btn2_cor: 2,
                  btn2_texto: 'CANCELAR',
                  btn2_link: '#',
                  btn2_link_next: false,
            }
            this.$refs.cc_mensagem.receber_dados(obj);
            return
          }

        });
    },

    resposta_modal_mensagem(variable){
        if(variable){
          this.montar_aposta_temporaria()
        }
    },

    montar_aposta_temporaria(){
        this.loading = true
        var body = {torneio_id: this.torneio.id, }
        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.post(this.base_url_api+'aposta/save/temp', body, header)
        .then(response => {

          if(response.data.resp.erro == null){
            window.location.href = process.env.BASE_LOCAL+"#/palpite/"+response.data.resp.aposta_id+"/editar"
          }
          // else{
          //   let te = response.data.resp.erro;
          //   this.$refs.cc_alert.receber_dados(te);
          // }

          this.loading = false
        })
        .catch(e => {
          this.errors.push(e);
          this.expluse_para_login()
        });
    },

    //************** entrar na aposta fim ***************** */

    start_time(){
      this.timer_torneio_horario = setInterval( function(){
        this.dif = this.dif - 1;
        this.time_regressivo = this.timestamp_horas_minutos_segundos( this.dif )
      }.bind(this), 1000);
    },

  },

}

</script>

<style scoped>

    .modal-content{
      background: #232633;
    }

    .card_fundo{
        background: #00000040 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #D1D1D105;
        border-radius: 10px;
    }

    input.form-control {
      background-image: url("../../assets/image/lupa.svg");
      background-size: 20px;
      background-position: right;
      background-repeat: no-repeat;
      /* background: #36394580 0% 0% no-repeat padding-box; */
      border: 2px solid #3E3E3E80;
      background-color: #36394580;
      border-radius: 5px;
      color: #FFFFFF4D;
      /* height: 500px; */
    }

    input.form-control::placeholder {
      color: #B7B7B780;
      font-size: 13px;
    }

</style>



// WEBPACK FOOTER //
// src/components/detalhes/detalhes.vue